import localforage from 'localforage';

// 带参数加载页面时，带参数跳转页面时 需要加载本地存储
// 这个对本地存储的获取做统一管理
class FJLoadLocalforage {
    _localforage = null;

    constructor() {
        this._localforage = localforage.createInstance({
            name: 'local-storage',
            version: 1.0,
            storeName: 'assets',
            description: 'Assets store at local storage.',
        });
    }

    async getItem(key) {
        try {
            const data = await this._localforage.getItem(key);
            return data;
        } catch (error) {
            return null;
        }
    }

    async setItem(key, value) {
        try {
            await this._localforage.setItem(key, value);
            return true;
        } catch (error) {
            return false;
        }
    }
}

const FJLoadLocalforageStore = new FJLoadLocalforage();

export default FJLoadLocalforageStore;
